let urlToPreload,
    mouseoverTimer,
    lastTouchTimestamp;

const prefetcher = document.createElement("link"),
      isSupported = prefetcher.relList &&
                    prefetcher.relList.supports &&
                    prefetcher.relList.supports("prefetch"),
      isDataSaverEnabled = navigator.connection && navigator.connection.saveData,
      allowQueryString = "instantAllowQueryString" in document.body.dataset,
      allowExternalLinks = "instantAllowExternalLinks" in document.body.dataset;

if (isSupported && !isDataSaverEnabled) {
  prefetcher.rel = "prefetch";
  document.head.appendChild(prefetcher);

  const options = { capture: true, passive: true };
  document.addEventListener("touchstart", touchstartListener, options);
  document.addEventListener("mouseover", mouseoverListener, options);
}

function touchstartListener(e) {
  lastTouchTimestamp = performance.now();
  const link = e.target.closest("a");

  if (isPreloadable(link)) {
    link.addEventListener("touchcancel", touchendAndTouchcancelListener, { passive: true });
    link.addEventListener("touchend", touchendAndTouchcancelListener, { passive: true });
    urlToPreload = link.href;
    preload(link.href);
  }
}

function touchendAndTouchcancelListener() {
  urlToPreload = undefined;
  stopPreloading();
}

function mouseoverListener(e) {
  if (performance.now() - lastTouchTimestamp < 1100) return;

  const link = e.target.closest("a");

  if (isPreloadable(link)) {
    link.addEventListener("mouseout", mouseoutListener, { passive: true });
    urlToPreload = link.href;

    mouseoverTimer = setTimeout(() => {
      preload(link.href);
      mouseoverTimer = undefined;
    }, 65);
  }
}

function mouseoutListener(e) {
  if (
    e.relatedTarget &&
    e.target.closest("a") === e.relatedTarget.closest("a")
  ) {
    return;
  }

  if (mouseoverTimer) {
    clearTimeout(mouseoverTimer);
    mouseoverTimer = undefined;
  } else {
    urlToPreload = undefined;
    stopPreloading();
  }
}

function isPreloadable(link) {
  if (!link || !link.href) return false;
  if (urlToPreload === link.href) return false;

  const url = new URL(link.href);

  return (
    (allowExternalLinks || url.origin === location.origin || "instant" in link.dataset) &&
    ["http:", "https:"].includes(url.protocol) &&
    !(url.protocol === "http:" && location.protocol === "https:") &&
    (allowQueryString || !url.search || "instant" in link.dataset) &&
    !(url.hash && url.pathname + url.search === location.pathname + location.search) &&
    !("noInstant" in link.dataset)
  );
}

function preload(href) {
  prefetcher.href = href;
}

function stopPreloading() {
  prefetcher.removeAttribute("href");
}